import { render } from "./Otp.vue?vue&type=template&id=53550733&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=53550733&scoped=true&lang=css"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53550733"]])

export default __exports__